/**
 * Wrapper difensivo su localStorage.
 *
 * In modalità privata (o in un ambiente Node durante i test) l'accesso a
 * localStorage può lanciare un'eccezione: qui viene sempre incapsulata, così
 * un errore di persistenza non manda in crash l'applicazione.
 */

/** @returns {Storage|null} */
function getStorage() {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null;
  } catch {
    return null;
  }
}

/**
 * Legge e deserializza un valore JSON.
 *
 * @template T
 * @param {string} key
 * @param {T} fallback valore restituito se la chiave manca o è corrotta
 * @returns {T}
 */
export function readJSON(key, fallback) {
  const storage = getStorage();
  if (!storage) return fallback;

  try {
    const raw = storage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}

/**
 * Serializza e salva un valore.
 *
 * @param {string} key
 * @param {unknown} value
 * @returns {boolean} `true` se il salvataggio è andato a buon fine
 */
export function writeJSON(key, value) {
  const storage = getStorage();
  if (!storage) return false;

  try {
    storage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}
